function About() {
  return (
    <div className="about-page">
      <h1>About</h1>
      <h2>Hi, I'm Jaiden.</h2>
      <p>Im a software engineer based in Canada, i like building things and solving complex problems</p>
      <p>I've been programming for over 7 years now, and have built a lot of things along the way</p>
      <p>My Interests are Programming and Outdoors stuff, Right now I'm mainly interested in C++ and game development, specifically game engines and the architecture around them.</p>
    </div>
  );
}

export default About;